<template>
  <div class="cupom">
    <SidebarLayout2 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- PAINEL AZUL -->
        <transition name="fade">
          <InfoPanel
            v-if="selectedCupons.length > 0"
            height="155"
            class="info-panel"
          >
            <template v-if="selectedCupons.length === 1" #content>
              <p class="info-panel--aux-text">
                <b>Cupom:</b> {{ selectedCupons[0].cupom }}
              </p>

              <p class="info-panel--aux-text">
                <b>Limite:</b> {{ couponLimit }}
              </p>
            </template>
            <template v-else #content>
              <p class="info-panel--aux-text">Você selecionou</p>
              <p class="info-panel--main-text">{{ selectedCupons.length }}</p>
              <p class="info-panel--aux-text">cupons</p>
            </template>
          </InfoPanel>
        </transition>

        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <!-- CADASTRAR -->
          <Button
            v-if="selectedCupons.length === 0"
            :hasIcon="true"
            :link="'/cupons-desconto/novo?tipo=1'"
            element="router-link"
            class="page-actions--button"
          >
            Cadastrar cupom
          </Button>

          <!-- CADASTRAR CUPONS EM MASSA-->
          <Button
            v-if="selectedCupons.length === 0"
            :hasIcon="true"
            :link="'/cupons-desconto/novo?tipo=2'"
            element="router-link"
            class="page-actions--button"
          >
            Cadastrar cupom em massa
          </Button>

          <!-- EDITAR CUPOM ÚNICO -->
          <Button
            v-if="selectedCupons.length > 0 && !isLots"
            :disabled="selectedCupons.length > 1"
            :link="`/cupons-desconto/editar/${selectedCupons[0].codigo}?tipo=1`"
            element="router-link"
            class="page-actions--button"
          >
            Editar
          </Button>

          <!-- EDITAR CUPOM EM MASSA -->
          <Button
            v-if="selectedCupons.length > 0 && isLots"
            :disabled="selectedCupons.length > 1"
            :link="
              `/cupons-desconto/editar/${selectedCupons[0].codigoAgrupador}?tipo=2`
            "
            element="router-link"
            class="page-actions--button"
          >
            Editar
          </Button>

          <!-- INATIVAR ÚNICO - CUPONS EM MASSA -->
          <Button
            v-if="selectedCupons.length > 0 && isLots"
            :disabled="!hasActiveSelectedCupons"
            variation="error"
            class="page-actions--button"
            @click=";(showAlertModal = true), (singleLots = true)"
          >
            Inativar cupom único
          </Button>

          <!-- INATIVAR AGRUPADOR - CUPONS EM MASSA -->
          <Button
            v-if="selectedCupons.length > 0 && isLots"
            :disabled="!hasActiveSelectedCupons"
            variation="error"
            class="page-actions--button"
            @click=";(showAlertModal = true), (singleLots = false)"
          >
            Inativar agrupador de cupom
          </Button>

          <!-- INATIVAR - CUPONS AVULSOS -->
          <Button
            v-if="selectedCupons.length > 0 && !isLots"
            :disabled="!hasActiveSelectedCupons"
            variation="error"
            class="page-actions--button"
            @click="showAlertModal = true"
          >
            Inativar
          </Button>
        </SidebarBlock>

        <!-- DICAS -->
        <SidebarBlock>
          <Heading>
            Dica
          </Heading>

          <RandomText :terms="tips" />
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <!-- VISUALIZAÇÃO ÚNICA -->
        <CouponsList
          ref="singleCoupon"
          v-if="!showLotsList"
          :lastExcludedCoupons="excludedCoupons"
          :selectedCupons="selectedCupons"
          :ratesOptions="ratesFilterOptions"
          @change="manageSelectedCupons"
          @couponsDeleted="selectedCupons = []"
        />

        <!-- VISUALIZAÇÃO EM TABS -->
        <Tabs
          v-if="showLotsList"
          class="tabs-padding"
          @changeTab="
            selectedCupons = []
            isLots = $event > 0
          "
        >
          <Tab title="Cupons avulsos" active>
            <CouponsList
              ref="singleCoupon"
              v-if="!isLots"
              :lastExcludedCoupons="excludedCoupons"
              :selectedCupons="selectedCupons"
              :ratesOptions="ratesFilterOptions"
              @change="manageSelectedCupons"
              @couponsDeleted="selectedCupons = []"
            />
          </Tab>

          <Tab title="Cupons em massa">
            <CouponsList
              ref="lotsCoupon"
              v-if="isLots"
              :lastExcludedCoupons="excludedCoupons"
              :selectedCupons="selectedCupons"
              :ratesOptions="ratesFilterOptions"
              :singleLots="singleLots"
              lots
              @change="manageSelectedCupons"
              @couponsDeleted="selectedCupons = []"
            />
          </Tab>
        </Tabs>
      </template>
    </SidebarLayout2>

    <AlertModal
      v-model="showAlertModal"
      text="Inativando o cupom, ele não estará mais disponível para ser editado e usado pelos clientes. Deseja continuar? "
      @alert-modal-confirm="excludeCoupons"
      @alert-modal-cancel="cancelExcludeCoupons"
    />
  </div>
</template>

<script>
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import Heading from '@/components/_base/elements/Heading'
import Button from '@/components/_base/elements/Button'
import InfoPanel from '@/components/_base/patterns/InfoPanel'
import SidebarBlock from '@/components/_base/patterns/SidebarBlock'
import RandomText from '@/components/_base/patterns/RandomText'
import AlertModal from '@/components/_base/patterns/AlertModal'
import Tab from '@/components/_base/patterns/Tab'
import Tabs from '@/components/_base/patterns/Tabs'
import CouponsList from '@/components/hotel/coupon/CouponsList.vue'

export default {
  name: 'Cupom',
  components: {
    SidebarLayout2,
    InfoPanel,
    Button,
    Heading,
    SidebarBlock,
    RandomText,
    AlertModal,
    Tab,
    Tabs,
    CouponsList
  },
  data() {
    return {
      showAlertModal: false,
      singleLots: false,
      isLoadingTableContent: true,
      isSingleCoupon: false,
      singleCoupon: null,

      breadcrumb: [
        {
          label: 'Letsbook'
        },
        {
          label: 'Cupons de desconto',
          url: '/cupons-desconto',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],
      pageTitle: 'Cupons de desconto',
      searchTerm: '',
      searchTermSelected: '',
      statusFilterOptions: [
        {
          label: 'Todos',
          value: 2,
          checked: false
        },
        {
          label: 'Ativos',
          value: 1,
          checked: true
        },
        {
          label: 'Inativos',
          value: 0,
          checked: false
        }
      ],
      statusFilterValue: {
        label: 'Ativos',
        value: 1,
        checked: true
      },
      ratesFilterValue: [],
      ratesFilterOptions: [],
      gridData: [],
      colsWidths: {
        cupom: '20%'
      } /** objeto com os tamanhos mínimos de cada coluna */,
      gridColumns: [
        /** colunas do grid */
        { name: 'cupom', alias: 'Cupom' },
        { name: 'valor', alias: 'Valor' },
        { name: 'ativo', alias: 'Status' },
        { name: 'quantidadeDisponivel', alias: 'Quant. Disponível' },
        { name: 'acoes', alias: '' }
      ],
      selectedCupons: [],
      tips: [
        {
          paragraph1:
            'Os cupons aplicam desconto em cima de outros descontos já configurados anteriormente.',
          paragraph2:
            'Ex: Flutuações com coeficientes menores que 100%, descontos da forma de pagamento Pix'
        }
      ],
      searchInputSuggestions: [],
      excludedCoupons: [] /** Armazena os cupons excluídos para passar para o filho */,
      isLots: false /** Controle da tab ativa */,
      // TODO rever esses 2 atributos para validar se tem cupons em massa
      showSingleList: true /** Controle de renderização da tab cupons únicos */,
      showLotsList: true /** Controle de renderização da tab cupons em massa */
    }
  },
  computed: {
    filterKey() {
      if (this.searchTerm.trim() !== '') return this.searchTermSelected

      return ''
    },
    filterValues() {
      return {
        status: this.statusFilterValue.value,
        rates: this.ratesFilterValue.map((item) => item.value).join(',')
      }
    },
    hasActiveSelectedCupons() {
      let hasActive = false

      for (let i = 0, len = this.selectedCupons.length; i < len; i++) {
        const cupom = this.selectedCupons[i]

        /** Se tem um ativo interrompe o loop */
        if (cupom.ativo) {
          hasActive = true
          break
        }
      }

      return hasActive
    },

    /** Formatar o retorno dos limites do cupom (reservas, noites ou pessoas) */
    couponLimit() {
      const cupom = this.selectedCupons?.[0]

      if (!cupom) return ''

      const amount = cupom.quantidadeMaximaUso || 0

      const pluralizer = (value, singular, plural) => {
        return `${value} ${value === 1 ? singular : plural}`
      }

      switch (cupom.tipoLimiteUso) {
        case 1:
          return 'Ilimitado'
        case 2:
          return `${pluralizer(amount, 'uso', 'usos')} por reserva`
        case 3:
          return `${pluralizer(amount, 'uso', 'usos')} por noite`
        case 4:
        default:
          return `${pluralizer(amount, 'uso', 'usos')} por pessoa`
      }
    }
  },
  watch: {
    searchTerm(newValue) {
      if (newValue === '') this.searchTermSelected = newValue
    }
  },
  created() {
    /** Filtro de tarifas */
    this.$coupon.getAvailableRates().then((response) => {
      for (let i = 0, len = response.data.length; i < len; i++) {
        const item = response.data[i]
        const obj = {}

        obj.fieldset = item.nome
        obj.subfields = []

        for (let j = 0, lenj = item.tarifas.length; j < lenj; j++) {
          const rate = item.tarifas[j]
          const subRate = {}

          subRate.label = rate.descricao
          subRate.value = rate.codigo

          obj.subfields.push(subRate)
        }

        this.ratesFilterOptions.push(obj)
      }
    })

    const localStorageItemName = `${location.host}_coupon_search`
    const localStorageSugg = localStorage.getItem(localStorageItemName)

    this.searchInputSuggestions = JSON.parse(localStorageSugg) || []
  },
  mounted() {
    /** Adiciona a escuta do evento de scroll */
    document.addEventListener('scroll', this.scrollHandler)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollHandler)
  },
  methods: {
    manageSelectedCupons(values) {
      this.selectedCupons = values
    },
    excludeSingleCoupon(codigo) {
      this.showAlertModal = true
      this.isSingleCoupon = true
      this.singleCoupon = [codigo]
    },
    cancelExcludeCoupons() {
      this.isSingleCoupon = false
      this.singleLots = null
      this.singleLots = false
    },
    excludeCoupons() {
      this.excludedCoupons = this.selectedCupons
      this.isSingleCoupon = false
      this.singleCoupon = null
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.tabs::v-deep {
  .tabs--head {
    margin: 0;
  }
  .tabs--content {
    padding-top: 10px;
    padding-left: 0;
  }
}
.cupom {
  .info-panel {
    flex-direction: column;
    justify-content: center;
    gap: 15px;

    &--main-text {
      width: 100%;
      line-height: 1;
      font-size: font-size('size-xx-large');
      font-weight: font-weight('weight-medium');

      &__smaller {
        font-size: font-size('size-large');
      }
    }

    &--aux-text {
      font-size: font-size('size-large');
      font-weight: font-weight('weight-light');

      b {
        font-weight: font-weight('weight-medium');
      }
    }
  }

  .page-actions {
    &--button {
      width: 100%;
      cursor: pointer;

      & + .page-actions--button {
        margin-top: 10px;
      }
    }
  }
}
</style>
